<template>
    <div>
        <div class="line__vertical-mains"></div>
        <sub-header :micrositeUrl="micrositeUrl" />
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box">
                <h1 class="caption__select">
                    <span>Seleccione una torre, clic para ver detalles</span>
                </h1>
                <map-highlight v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel"  :type="type" />
                
                <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel" :desarrollo="desarrollo" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div>
                <Availables class="availables-mobile" :amountAvailables="amountAvailables" :nivel="nivel" :url="url" />
            </div>
            <div class="select__box" :class="selectHide">
                <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" />
                <Availables  class="availables-desk" :amountAvailables="amountAvailables" :nivel="nivel" :url="url" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight.vue";
import Select from "../../core/Select.vue";
//change
import Availables from "../../core/rediseno/Availables.vue";
import Button from "../../core/Button.vue"; 
export default {
    name: "Main",
    components: {
        SubHeader,
        MapHighlight,
        Select,
        Availables,
        Button,
    },
    data() {
        return {
            id: 48,
            nivel: "towerStage",
            levelId: 0,
            type: "departamento",
            desarrollo: "torreaireaplus",
            arrFilteredLocations: [],
            url: "torreaireaplus",
            micrositeUrl: "https://tresmarias.com.mx/torreairea/departamentos",
            imgSet: [{
                name: 'torreaireaplus',
                url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torreaireaplus/MainTorreairea.png',
                width: '1050',
                height: '388',
                id: 48,
                levelId: 0,
                route: 'torreaireaplus',
                nivel: 'towerStage',
                transform: '',
                viewBox: '0 0 1080 388'
            }],
           /*  indicators: [
                { id: 54, text: 'TORRE 11', transform: 'matrix(1 0 0 1 375 308)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 486, y1: 300.62, x2: 778, y2: 300.62, status: true },
            ], */
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false
        };
    },

    computed: {
        ...mapGetters({
          locations: "getLocations",
        }),
        development() {
            return { id: this.id, level: 0 };
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.available > 0
            );
            return newArrfiltered;
        },
        selectHide() {
            if (this.rangeFilter == false) {
                return 'u__dipslay--none'
            } else {
                return ''
            }
        }
    },
    methods: {
        ...mapActions(["getTowerStage", "clearCoords"]),
        updateAvailable() {
    // Modifica el estado de `this.locations`
    if (this.locations && this.locations[1]) {
      this.locations[1].available = 5;
      // console.log("Updated locations:", this.locations);
    }
  },
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
    },
    async created() {
      await this.clearCoords();
      await this.getTowerStage(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords()
  },
};
</script>
